import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=96d35f40&scoped=true&"
var script = {}
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=96d35f40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d35f40",
  null
  
)

export default component.exports